<template >
  <div v-if="value" class="element-modal element-signature-popup">
    <div class="container">
      
      <div class="header">
        가입설계를 위한 동의
      </div>

      <div class="section">
        <div class="container">
          <div class="image">
            <img src="/static/sign-1.png" />
          </div>
        </div>
      </div>

      <div class="footer">
        <div class="button" @click="click(false)">
          확인
        </div>
      </div>
      
    </div>
  </div>
</template>
<script>
export default {
  props: [ "value" ],
  computed: {
    model: {
      get(){
        return this.value;
      },
      set( value ){
        this.$emit( "input", value );
      }
    }
  },
  methods: {

    click( value ){
      this.$emit( "input", false );
    }

  }

}
</script>
